import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const AttachIcon: FC<SvgIconProps> = (props) => (
	<SvgIcon {...props}>
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_6445_65943)">
				<path
					d="M6.75003 9.74991C7.03679 10.2641 7.44062 10.7036 7.92881 11.0328C8.417 11.3619 8.97583 11.5715 9.56007 11.6446C10.1443 11.7176 10.7375 11.652 11.2917 11.4532C11.8459 11.2543 12.3455 10.9277 12.75 10.4999L15.75 7.49991C16.4462 6.80371 16.8373 5.85947 16.8373 4.87491C16.8373 3.89034 16.4462 2.9461 15.75 2.24991C15.0538 1.55371 14.1096 1.1626 13.125 1.1626C12.1405 1.1626 11.1962 1.55371 10.5 2.24991L9.00003 3.74991M11.25 8.24991C10.9633 7.73567 10.5594 7.29619 10.0713 6.96703C9.58306 6.63787 9.02423 6.42829 8.43999 6.35526C7.85574 6.28223 7.26251 6.3478 6.70832 6.54666C6.15413 6.74552 5.65455 7.07208 5.25003 7.49991L2.25003 10.4999C1.55384 11.1961 1.16272 12.1403 1.16272 13.1249C1.16272 14.1095 1.55384 15.0537 2.25003 15.7499C2.94622 16.4461 3.89046 16.8372 4.87503 16.8372C5.8596 16.8372 6.80384 16.4461 7.50003 15.7499L9.00003 14.2499"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_6445_65943">
					<rect width="18" height="18" fill="white" />
				</clipPath>
			</defs>
		</svg>
	</SvgIcon>
);
